import { FC, PropsWithChildren } from "react";
import { Box, BoxProps, Flex, Image } from "@chakra-ui/react";
import { base } from "@looksrare/chakra-theme";
import { RainbowText } from "@looksrare/uikit";
import { GreyBox, Heading, SectionContainer, ParallaxImage, TextContent, useIsMobile } from "./shared";

const imageWidth = { base: "auto", md: "310px", lg: "346px", xl: "410px", "2xl": "434px" };
const rootMargin = { top: 200, right: 200, bottom: 200, left: 200 };

const HeroText = () => (
  <Box px={12} py={{ base: 12, md: 16 }} maxWidth={{ base: "auto", md: "calc(50% + 64px)" }}>
    <Heading color="text-inverse">Rarity.</Heading>
    <RainbowText
      bg={base.linearGradient}
      as="h2"
      fontSize={{ base: "2.25rem", xl: "4rem" }}
      lineHeight={{ base: "3rem", xl: "4.5rem" }}
      letterSpacing="-0.02em"
      bold
      mb={8}
    >
      Reimagined.
    </RainbowText>
    <TextContent color="text-inverse-03" mb={8}>
      For the gem hunters and connoisseurs who won&apos;t settle for anything less than the most exclusive of traits. 
    </TextContent>
    <TextContent color="text-inverse-03">
      Uncover the properties that make your NFTs unique — and see how similar pieces are trading.
    </TextContent>
  </Box>
);

const Phone: FC<PropsWithChildren<BoxProps>> = (props) => (
  <Box position="relative" {...props}>
    <Image src="/images/app-landing-page/rarity-phone.png" alt="rarity-phone" />
    <Box position="absolute" top={0} left={0} height="100%" width="100%">
      <ParallaxImage
        src="/images/app-landing-page/rarity-pane-1.png"
        alt="rarity-pane-1"
        parallaxProps={{
          translateY: ["-20px", "0px"],
          rootMargin,
        }}
      />
      <ParallaxImage
        src="/images/app-landing-page/rarity-pane-2.png"
        alt="rarity-pane-2"
        parallaxProps={{
          translateY: ["20px", "0px"],
          rootMargin,
        }}
      />
      <ParallaxImage
        src="/images/app-landing-page/rarity-pane-3.png"
        alt="rarity-pane-3"
        parallaxProps={{
          translateY: ["-20px", "0px"],
          rootMargin,
        }}
      />
      <ParallaxImage
        src="/images/app-landing-page/rarity-pane-4.png"
        alt="rarity-pane-4"
        parallaxProps={{
          translateY: ["20px", "0px"],
          rootMargin,
        }}
      />
    </Box>
  </Box>
);

const MobileRarity = () => (
  <SectionContainer baseMaxWidth="390px">
    <GreyBox bg="ui-01-inverse" pb={{ base: 12, md: undefined }}>
      <HeroText />
      <Phone />
    </GreyBox>
  </SectionContainer>
);

export const Rarity = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileRarity />;
  }

  return (
    <SectionContainer>
      <Flex position="relative" justifyContent="start">
        <GreyBox bg="ui-01-inverse" position="absolute" left={0} top="50%" transform="translateY(-50%)" width="100%">
          <Flex justifyContent="end">
            <HeroText />
          </Flex>
        </GreyBox>
        <Phone width={imageWidth} />
      </Flex>
    </SectionContainer>
  );
};
